import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NbFormService } from '@showye/nbweb-input/nb-form';
import { ShowyePageApiService, ShowyePageAuthService, ShowyePageUtilService } from '@showye/showye-page-base';
import { format } from 'date-fns';

@Component({
  templateUrl: './launch.component.html',
  styleUrls: ['./task.scss'],
})
export class LaunchComponent implements OnInit, OnDestroy {
  public route$: Subscription | null = null;

  downloadUrl = this.api.getDownloadUrl();
  uploadUrl = this.api.getUploadUrl();
  importUrl = this.api.getImportUrl();
  token: any = this.auth.token;
  pdfUrl = '../../../../assets/pdf/web/viewer.html?file=';

  title: any;
  sign: any;
  comment: any;
  data: any = {};
  staffs: any = [];
  staffMap: any = {};
  roleMap: any = {};
  edges: any = [];
  isDraftNodeId = null;

  ngOnDestroy(): void {
    if (this.route$) {
      this.route$.unsubscribe();
    }
  }

  goBack(): void {
    this.location.back();
  }

  draftId: any;

  params: any = {}; // 预置参数，由业务系统传入，作为预加载器的参数
  ngOnInit(): void {
    this.reloadDomains();
    this.reloadStaffs();
    this.reloadRoles();
    this.route$ = this.route.params.subscribe((params: Params) => {
      if (!!params.title && params.title.trim().length > 0) {
        this.title = params.title.trim();
      }
      if (!!params.nodeId && !!params.id) {
        // 正常跳转，使用 nodeId，读取所有该 node 的操作、预加载
        this.nodeId = +params.nodeId;
        this.draftId = +params.id;
        this.isDraftNodeId = params.nodeId;
        this.api.getNodeViewById(params.nodeId).subscribe((x: any) => {
          this.node = x.data;
          this.init(1);
        });
      } else if (!!params.taskId) {
        this.taskId = +params.taskId;
        this.api
          .getProcessLaunchInfo({
            taskId: params.taskId,
            nodeId: params.nodeId,
            process: params.processCode,
            node: params.nodeCode,
          })
          .subscribe((e: any) => {
            this.nodeId = e.data.node.id;
            this.node = e.data.node;
            this.ccUsers = e.data.data.apply.ccUsers;
            this.api.getNodeViewByCode(params.processCode, params.nodeCode).subscribe((x: any) => {
              this.node.processTitle = x.data.processTitle;
            });
            this.edges = e.data.edges;
            this.draft = e.data;
            if (!e.data.data && !!this.node && !!this.node.preload) {
              this.processPreloadData(this.node.preload);
            }
            const fm = [...e.data.forms, { displayName: '抄送', code: '$cc', fields: [] }];
            this.formGroups = this.formService.reloadForm(fm, this.data, !!this.data && Object.keys(this.data).length > 0);
            this.index = 0;
            if (fm.length > 0) {
              this.currentForm = fm[0];
              this.code = this.currentForm.code;
              this.forms = [fm[0]];
            }
            this.refreshDraftData();
          });
      } else if (!!params.processCode && params.processCode.length > 0 && !!params.nodeCode && params.nodeCode.length > 0) {
        // 流程 + 节点 代码 跳转
        this.api.getNodeViewByCode(params.processCode, params.nodeCode).subscribe((x: any) => {
          this.nodeId = x.data.id;
          this.node = x.data;
          this.init(0);
        });
      } else {
        this.msg.error('请指定流程和开始节点');
        this.location.back();
      }
      this.params = { ...params };
    });
  }

  reloadStaffs(): void {
    this.api.listUsers().subscribe((e: any) => {
      this.staffs = e.data ? e.data : [];
      this.staffMap = e.data ? e.data.reduce((a: any, c: any) => ({ ...a, [c.id]: c }), {}) : {};
    });
  }

  reloadRoles(): void {
    this.api.listRoles().subscribe((e: any) => {
      this.roleMap = e.data ? e.data.reduce((a: any, c: any) => ({ ...a, [c.id]: c }), {}) : {};
    });
  }

  showCcModal = false;
  ccUsers: any = [];
  ccUserPop: any = [];

  popAddCcUser(): void {
    this.ccUserPop = this.ccUsers;
    this.showCcModal = true;
  }

  confirmCC(): void {
    this.ccUsers = this.ccUserPop;
    this.showCcModal = false;
  }

  nodeId: any;
  node: any;
  taskId: any;

  init(type: any): void {
    if (!!this.node && !!this.node.preload) {
      this.processPreloadData(this.node.preload);
    }
    this.reloadEdges();
    this.reloadForms();
    if (type === 1) {
      this.reloadDraft();
    }
  }

  reloadEdges(): void {
    this.api.listEdgesByNode(this.nodeId).subscribe((e: any) => {
      this.edges = e.data;
    });
  }

  draft: any;

  reloadDraft(): void {
    this.api.getMyTaskDraftByNode(this.nodeId).subscribe((e: any) => {
      if (!!e && !!e.data) {
        this.draft = e.data;
        this.ccUsers = e.data.data.apply.ccUsers;
        this.title = this.draft.title;
        this.refreshDraftData();
      }
    });
  }

  refreshDraftData(): void {
    // console.log('check refresh draft: ', !!this.formGroups, !!this.draft.data, Object.keys(this.draft.data).length > 0);
    if (!!this.formGroups && !!this.draft && !!this.draft.data && Object.keys(this.draft.data).length > 0) {
      // console.log('reload draft: ', this.draft);
      this.formService.reloadData(this.formGroups, this.forms, this.draft.data);
    }
  }

  reloadForms(): void {
    if (!!this.nodeId) {
      this.api.getFormByNode(this.nodeId).subscribe((e: any) => {
        const fm = e.data;
        this.formGroups = this.formService.reloadForm(fm, this.data, !!this.data && Object.keys(this.data).length > 0);
        // this.formGroups = this.fb.group(e.data.reduce((acc: any, cur: any) => ({ ...acc, [cur.code]: new FormGroup({}) }), {}));
        this.index = 0;
        if (fm.length > 0) {
          this.currentForm = fm[0];
          this.code = this.currentForm.code;
          this.forms = fm;
        }
        if (this.isDraftNodeId) {
          this.refreshDraftData();
        }
      });
    }
  }

  processPreloadData(preload: any): void {
    // console.log('has preload: ', e.data.preload);
    if (preload && preload.length > 0) {
      preload.forEach((p: any) => {
        if (!!p.code && !!p.assign && p.assign.length > 0) {
          this.api.callFlowPreloader(p.code, this.params).subscribe((res: any) => {
            // console.log('preload data: ', p.assign, ' @ ', p.code, ' >> ', res.data);
            p.assign.forEach((ass: any) => {
              if (ass.path && ass.expression) {
                // console.log('calculate: ', ass.expression);
                const result = this.formService.calculateExpression(ass.expression, res);
                if (result !== null) {
                  // console.log('assign: ', this.data, '  >>>  ', ass.path, '  =  ', result);
                  this.data = this.formService.assignDeep(this.data, ass.path, result);
                }
              }
            });
          });
        }
      });
      if (this.formGroups) {
        this.formService.reloadData(this.formGroups, this.forms, this.data);
      }
    }
  }

  forms: any = [];
  formGroups: FormGroup | null = null;

  get currentGroup(): FormGroup {
    return this.formGroups && this.formGroups.get(this.code) ? (this.formGroups.get(this.code) as FormGroup) : new FormGroup({});
  }

  code = '';
  currentData: any = {};
  currentForm: any = {};
  index: any = 0;

  changeIndex(id: any): void {
    this.data[this.currentForm.code] = this.currentGroup.value;
    this.currentForm = this.forms[id];
    this.code = this.currentForm.code;
    this.currentData = this.data[this.currentForm.code];
  }

  domains: any = [];

  reloadDomains(): void {
    this.api.listDomains().subscribe((e: any) => {
      this.domains = e.data;
    });
  }

  showSubmitModal = false;
  submitAction: any;
  loadingSubmit = false;
  loadingSave = false;

  popSubmitTask(op: any): void {
    this.submitAction = op;
    if (op.signRequired || op.reasonRequired) {
      this.showSubmitModal = true;
    } else {
      this.submitTask();
    }
  }

  submitTask(): void {
    if (!this.title) {
      this.title = this.node.processTitle + '-' + format(new Date(), 'yyyyMMddHHmmss');
    }
    // console.log(this.formGroups.value);
    const detailed = this.coder.removeNullProperties(this.formGroups?.value);
    detailed.apply.ccUsers = this.ccUsers;
    if (!!this.submitAction) {
      const params = {
        data: detailed,
        routeId: this.submitAction.id,
        title: this.title,
        comment: this.comment,
        sign: this.sign,
        ccUsers: this.ccUsers,
      };
      // console.log(params);
      this.loadingSubmit = true;
      this.api.submitFlowLaunch(params).subscribe(
        () => {
          this.loadingSubmit = false;
          // 如果是草稿发起删除草稿数据
          if (this.draftId) {
            this.delete(this.draftId);
          } else {
            // this.showSubmitModal = false;
            this.goBack();
          }
        },
        () => (this.loadingSubmit = false),
      );
    } else {
      // console.log('缺失 routeId');
    }
  }

  // 删除草稿
  delete(id: any): void {
    this.api.deleteTaskDraft({ id }).subscribe((e: any) => {
      if (e.code === 200) {
        this.goBack();
      }
    });
  }

  constructor(
    private api: ShowyePageApiService,
    private coder: ShowyePageUtilService,
    private auth: ShowyePageAuthService,
    modalSrv: NzModalService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private formService: NbFormService,
    public msg: NzMessageService,
    public notify: NzNotificationService,
  ) {
    modalSrv.closeAll();
  }

  downLoad = this.api.getDownloadUrl();

  saveDraft(): void {
    const detailData = this.coder.removeNullProperties(this.formGroups?.value);
    // 抄送信息保存
    detailData.apply.ccUsers = this.ccUsers;
    const params = {
      data: detailData,
      title: this.title,
      nodeId: this.nodeId,
    };
    // console.log(params);
    this.loadingSave = true;
    this.api.saveTaskDraft(params).subscribe(
      () => {
        this.loadingSave = false;
        this.msg.success('保存成功');
      },
      () => (this.loadingSave = false),
    );
  }
}
